import { Chat } from '@mui/icons-material';

/**
 * Chat bubble icon for the header, styled to match the account icon.
 */
export const ZendeskChatHeaderIcon = () => (
  <Chat
    sx={{
      fontSize: 24,
      color: '#4E5968',
    }}
  />
);
